import React from 'react';
import { hydrate } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { getConfig } from '@cian/config/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import { IHeaderV1Schema } from '../../../shared/repositories/header/entities/response/HeaderV1Schema';
import { TDropdownType } from '../../dropdown_menu/interfaces';
import { DropdownMenuContainer } from '../../dropdown_menu/container';
import { TopMenuContainer } from '../../../shared/containers/TopMenuContainer';
import { checkCianProEnabled } from '../../../shared/utils/checkCianProEnabled';
import { getDealRentLinkExperiment } from '../../../shared/utils/getDealRentLinkExperiment';

export interface IInitDropdownMenus {
  headerData?: IHeaderV1Schema;
  newHeaderEnabled?: boolean;
}

export const initializeDropdownMenus = (params: IInitDropdownMenus) => {
  const { newHeaderEnabled } = params;
  if (!newHeaderEnabled) {
    const dropdowns: TDropdownType[] = ['rent', 'sale', 'newbuildings', 'commercial', 'mortgage'];
    const data = window.__header_dropdown_menus_data__;
    const logger = getLogger();

    dropdowns.forEach(name => {
      const container = document.querySelector(`[data-fh-menu-dropdown-${name}] > div`);
      hydrate(
        <ErrorLogComponent logger={logger}>
          <DropdownMenuContainer {...data[name]} />
        </ErrorLogComponent>,
        container,
      );
    });
  }
};

export interface IInitNewTopMenu {
  headerData: IHeaderV1Schema;
  newHeaderEnabled?: boolean;
}

export const initializeNewTopMenu = (params: IInitNewTopMenu) => {
  const { headerData, newHeaderEnabled } = params;

  const config = getConfig();

  if (newHeaderEnabled) {
    const data = window.__header_dropdown_menus_data__;
    const regionId = window.__header_region_id__;
    const experiments = window.__header_experiments__;
    const bottomMenuData = window.__header_bottom_menu_data;
    const container = document.getElementById('bottom-menu-titles');
    const specialPromoLinkData = window.__header_special_promo_link_data__;
    const dealRegions = window.__header_deal_regions__;
    const isCianProEnabled = checkCianProEnabled({ config, headerData, experiments });
    const dealRentLinkExperiment = getDealRentLinkExperiment({ experiments, regionId, dealRegions });

    if (container && !bottomMenuData) {
      hydrate(
        <ErrorLogComponent logger={getLogger()}>
          <TopMenuContainer
            dropdownMenusData={data}
            specialPromoLinkData={specialPromoLinkData}
            headerData={headerData}
            activeKey={config.get<string>('section') as string}
            regionId={regionId}
            isCianProEnabled={isCianProEnabled}
            dealRentLinkExperiment={dealRentLinkExperiment}
          />
        </ErrorLogComponent>,
        container,
      );
    }
  }
};
